export function goTo(url) {
  if (url) {
    window.location = url;
  }
}
